import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { IconCheck, IconCopy } from "@tabler/icons-react";
import { LangConstant } from "const";

const GeneratedPassword = ({ isOpen, password, onClose }) => {
  const { t: getLabel } = useTranslation();

  const langObj = getLabel(LangConstant.OBJ_RANDOM_ADMIN_PASSWORD, { returnObjects: true });

  const [isCopied, setIsCopied] = useState(false);

  const handleClose = () => {
    onClose();
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(password);
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 3000);
  };

  useEffect(() => {
    setIsCopied(false);
  }, [password]);

  if (!isOpen) return null;

  return (
    <>
      <div className="modal-backdrop fade show"></div>
      <div className="modal modal-blur fade show d-block" tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-sm modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header" style={{ marginTop: 10 }}>
              <h5 className="modal-title">{langObj.title}</h5>
              <button type="button" className="btn-close" aria-label="Close" onClick={handleClose}></button>
            </div>
            <div className="modal-body d-flex align-items-center justify-content-between gap-3">
              <span>{getLabel(langObj.content, { password })}</span>
              <button
                className="btn btn-icon btn-ghost-primary"
                title={langObj.copy}
                disabled={isCopied}
                onClick={handleCopy}
              >
                {isCopied ? (
                  <IconCheck size={18} color="#1976d2" />
                ) : (
                  <IconCopy size={18} />
                )}
              </button>
            </div>
            <div className="modal-footer">
              <button className="btn btn-primary" onClick={handleClose}>
                {langObj.close}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GeneratedPassword;
